const defaultPolicyEdgeColor = 'gray';
const defaultPolicyEdgeMarkerSize = 14;

const sanitizePolicyNodeDataForDomain = (data = {}) => {
    const {
        showHandle,
        highlighted,
        activeSourceHandleId,
        activeTargetHandleId,
        ...domainData
    } = data || {};

    return domainData;
};

const sanitizePolicyNodeForDomain = (node = {}) => {
    const {
        selected,
        dragging,
        resizing,
        measured,
        width,
        height,
        positionAbsolute,
        draggable,
        selectable,
        deletable,
        zIndex,
        ...domainNode
    } = node || {};

    return {
        ...domainNode,
        data: sanitizePolicyNodeDataForDomain(domainNode.data || {})
    };
};

const sanitizePolicyEdgeStyleForDomain = (style = {}) => {
    const {
        filter,
        opacity,
        zIndex,
        transition,
        ...baseStyle
    } = style || {};

    return {
        ...baseStyle,
        stroke: defaultPolicyEdgeColor,
        strokeWidth: 2,
    };
};

const sanitizePolicyEdgeForDomain = (edge = {}) => {
    const {
        selected,
        reconnectable,
        selectable,
        deletable,
        updatable,
        focusable,
        ...domainEdge
    } = edge || {};

    return {
        ...domainEdge,
        style: sanitizePolicyEdgeStyleForDomain(domainEdge.style || {}),
        markerEnd: domainEdge.markerEnd
            ? {
                ...domainEdge.markerEnd,
                color: defaultPolicyEdgeColor,
                width: defaultPolicyEdgeMarkerSize,
                height: defaultPolicyEdgeMarkerSize,
            }
            : domainEdge.markerEnd,
    };
};

export const createPolicyDomainDiagram = (nodes = [], edges = []) => {
    const safeNodes = Array.isArray(nodes) ? nodes : [];
    const safeEdges = Array.isArray(edges) ? edges : [];

    return {
        nodes: safeNodes.map(sanitizePolicyNodeForDomain),
        edges: safeEdges.map(sanitizePolicyEdgeForDomain)
    };
};

export const toPolicyDomainFile = (file) => {
    if (!file || typeof file !== 'object' || !file.diagram) {
        return file;
    }

    const persistedDiagram = createPolicyDomainDiagram(file.diagram.nodes || [], file.diagram.edges || []);

    return {
        ...file,
        diagram: {
            ...file.diagram,
            nodes: persistedDiagram.nodes,
            edges: persistedDiagram.edges,
        },
    };
};
